import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { CardElementsBaseComponent } from '../shared/card-elements-base.component';
import { CardResolveHelper } from './card-resolver.helper';

/**
 * The component responsible to resolve and render the building block
 */
@Component({
  selector: 'cu-review-card-renderer-resolver',
  template: `<ng-container #reviewCardContainer></ng-container>`
})
export class ReviewCardRendererResolverComponent extends CardElementsBaseComponent implements OnInit, OnChanges {
  /**
   * Reference to  controlContainer where building block is rendered
   */
  @ViewChild('reviewCardContainer', { static: true, read: ViewContainerRef })
  public cardContainer: ViewContainerRef;
  private componentRef: ComponentRef<CardElementsBaseComponent>;

  constructor(private readonly componentFactoryResolver: ComponentFactoryResolver) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // Updating Card Index whenever it changes
    if (changes.cardIndex && this.componentRef) {
      this.componentRef.instance.cardIndex = this.cardIndex;
    }
  }

  public ngOnInit(): void {
    this.componentRef = new CardResolveHelper(
      this.componentFactoryResolver,
      this.cardContainer,
      this.page,
      this.card,
      this.cardIndex,
      this.pageSubmitted$
    ).resolve(this.card.helper.reviewRendererType);
  }
}
